import { invokeAuth0EdgeFunction } from './edgeFunctions';
import { sb } from './supabase';

/** Provision demo programme from template org into caller's organisation. */
export async function provisionDemo(getAccessTokenSilently, triggeredBy = 'regenerate') {
  return invokeAuth0EdgeFunction(
    'provision-demo',
    { triggered_by: triggeredBy },
    getAccessTokenSilently,
  );
}

/** Validate and audit a demo persona preview session. */
export async function startDemoPersonaSession(getAccessTokenSilently, personaProfileId, programmeId) {
  return invokeAuth0EdgeFunction(
    'demo-login',
    { persona_profile_id: personaProfileId, programme_id: programmeId },
    getAccessTokenSilently,
  );
}

/** Fetch demo personas for an organisation. */
export async function fetchDemoPersonas(orgId) {
  const { data, error } = await sb
    .from('profiles')
    .select('id, full_name, email, job_title, is_demo_persona')
    .eq('organisation_id', orgId)
    .eq('is_demo_persona', true)
    .order('full_name');
  if (error) throw error;
  return data || [];
}

/** Latest demo programme for org (if any). */
export async function fetchDemoProgramme(orgId) {
  const { data, error } = await sb
    .from('programmes')
    .select('id, name, description, is_demo, cloned_from_template_id, created_at')
    .eq('organisation_id', orgId)
    .eq('is_demo', true)
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return data;
}
